<div class="upload-documentos-consulta-container">
  <div class="header">
    <div class="header-title">
      <h1>Upload de Documentos</h1>
      <p class="subtitle">Consulta</p>
    </div>
    <div class="header-actions">
      <span class="badge-count" *ngIf="!loading">{{ documentos.length }} documento(s)</span>
      <button class="btn btn-outline-secondary" (click)="voltar()">
        <i class="fa fa-arrow-left"></i> Voltar
      </button>
    </div>
  </div>

  <div class="card-box">
    <h5 class="section-title"><i class="fa fa-cloud-upload"></i> Enviar novos documentos</h5>
    <div class="d-flex justify-content-center mb-3">
      <button type="button" class="btn btn-success" (click)="adicionarLinha()">
        <i class="fa fa-plus"></i> Adicionar
      </button>
    </div>

    <div class="alert alert-warning py-2 mb-3">
      Apenas arquivos no formato .pdf serão aceitos.
    </div>

    <div class="table-responsive mb-3">
      <table class="table table-sm align-middle mb-0">
        <thead>
          <tr>
            <th style="width: 40px;"></th>
            <th>Descrição</th>
            <th>Tipo Arquivo</th>
            <th>Arquivo</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let linha of linhasUpload; let i = index">
            <td>
              <input type="checkbox" [(ngModel)]="linha.selecionado" />
            </td>
            <td>
              <input class="form-control" [(ngModel)]="linha.descricao" placeholder="Descrição" />
            </td>
            <td>
              <select class="form-control" [(ngModel)]="linha.idTipoArquivo">
                <option [ngValue]="null">Selecione</option>
                <option *ngFor="let tipo of tiposArquivo" [ngValue]="tipo.id">{{ tipo.nome }}</option>
              </select>
            </td>
            <td>
              <input
                type="file"
                class="form-control"
                accept=".pdf,application/pdf"
                (change)="onSelecionarArquivo($event, linha)" />
              <small class="text-muted">{{ getNomeArquivo(linha) }}</small>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="mb-3">
      <button type="button" class="btn btn-danger" (click)="removerLinhasSelecionadas()">
        <i class="fa fa-trash"></i> Remover
      </button>
    </div>

    <div class="text-end">
      <button class="btn btn-primary" type="button" [disabled]="salvando" (click)="enviarDocumentos()">
        <i class="fa fa-upload"></i>
        {{ salvando ? ' Enviando...' : ' Enviar documentos' }}
      </button>
    </div>
  </div>

  <div class="card-box" *ngIf="!loading && documentos.length === 0">
    <p class="empty-message mb-0">Nenhum documento vinculado a esta consulta.</p>
  </div>

  <div class="card-box" *ngIf="!loading && documentos.length > 0">
    <h5 class="doc-title"><i class="fa fa-folder-open"></i> Documentos vinculados</h5>
    <div class="table-responsive">
      <table class="table table-hover mb-0">
        <thead>
          <tr>
            <th style="width: 60px;">#</th>
            <th>Tipo</th>
            <th>Nome</th>
            <th>Descrição</th>
            <th style="width: 140px;">Ação</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let documento of documentos; let i = index">
            <td>{{ i + 1 }}</td>
            <td><span class="tipo-chip">{{ documento.tipo || 'Documento' }}</span></td>
            <td>{{ documento.nome || '-' }}</td>
            <td>{{ documento.descricao || '-' }}</td>
            <td>
              <a class="btn btn-sm btn-open" [href]="resolverUrlDocumento(documento.path)" target="_blank" rel="noopener">
                <i class="fa fa-external-link"></i> Abrir
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
